import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import newsImage1 from '../assets/news_1.webp';
import newsImage2 from '../assets/news_2.webp';
import newsImage3 from '../assets/news_3.webp';
import newsImage4 from '../assets/news_4.webp';
import newsImage5 from '../assets/news_5.webp';
import newsImage6 from '../assets/news_6.webp';
import newsImage7 from '../assets/news_7.webp';
import newsImage8 from '../assets/news_8.webp';

const NewsSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box mt={6}>
      <Typography variant="h3" align="center" gutterBottom>
        News
      </Typography>
      <Grid container spacing={4} mt={0} mb={8}>
        <Grid item xs={12}>
          <Card>
            <CardActionArea
              component="a"
              href={t('news.link9')}
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText9')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000008.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage8}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText8')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000007.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage7}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText7')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000006.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage6}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText6')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000007.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage7}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText7')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000006.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage6}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText6')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000005.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage5}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText5')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000003.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage4}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText4')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000004.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage3}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText3')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000002.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage2}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText2')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardActionArea
              component="a"
              href="https://prtimes.jp/main/html/rd/p/000000001.000151358.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CardMedia
                component="img"
                height="auto"
                image={newsImage1}
                alt="News Image"
              />
              <CardContent>
                <Typography variant="h6" component="div" align="left">
                  {t('news.linkText1')}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NewsSection;
